import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import { Typography } from "@material-ui/core";
import { useWindowDimensions } from "./window-dimensions";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  header: {
    left: 0,
    top: 78,
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "row",
    zIndex: 10,
    flex: 9,
    height: 70,
  },
  iconImg: {
    width: 50,
    height: 50,
    marginRight: 15,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 5,
      width: 30,
      height: 30,
      marginRight: 5,
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      width: 30,
      height: 30,
      marginRight: 0,
    },
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      justifyContent: "center",
    },
  },
  collapse: {
    position: "absolute",
    backgroundColor: "#FFFFFF",
    marginTop: 70,
    zIndex: 10,
    maxHeight: 300,
    overflowY: "auto",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  singleTab: {
    flex: 3,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    cursor: "context-menu",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#F1F1F1",
    },
    borderStyle: "solid",
    borderColor: "#C4C4C4",
    borderWidth: "0px 0.5px 0px 0px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "space-around",
      padding: 5,
    },
  },
  collapseTab: {
    display: "flex",
    flex: 3,
  },
  collapseItem: {
    borderStyle: "solid",
    borderColor: "#C4C4C4",
    borderWidth: "1px 0px 0px 0px",
    padding: "15px 50px",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "10px 10px",
    },
  },
  expandIcon: {
    marginRight: 10,
    //marginLeft: 20,
    marginLeft: 40,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 20,
      marginRight: 5,
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 10,
      marginRight: 2,
    },
    height: 25,
  },
  collapseTabContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  collapseText: {
    width: 210,
    fontSize: 15,
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
    },
  },
}));

const SubheaderComponent = ({ props }) => {
  const classes = useStyles();

  const { width } = useWindowDimensions();

  return (
    <React.Fragment>
      <div className={classes.header}>
        {props.map((item) => (
          <>
            {!item.collapse ? (
              <div className={classes.singleTab} onClick={item.onClick}>
                <img
                  className={classes.iconImg}
                  src={item.img.src}
                  alt={item.img.alt}
                />
                <div className={classes.textContainer}>{item.text}</div>
              </div>
            ) : (
              <div
                className={classes.collapseTab}
                style={{ minWidth: width / props.length }}
              >
                <div
                  onClick={() => item.setOpen(!item.open)}
                  className={classes.singleTab}
                >
                  <img
                    className={classes.iconImg}
                    src={item.img.src}
                    alt={item.img.alt}
                  />
                  <div className={classes.collapseTabContent}>
                    <div className={classes.textContainer}>{item.text}</div>
                    <div
                      className={classes.expandIcon}
                      style={{ display: width < 350 ? "none" : "block" }}
                    >
                      {item.open ? (
                        <ExpandLess
                          fontSize={width < 600 ? "small" : "medium"}
                        />
                      ) : (
                        <ExpandMore
                          fontSize={width < 600 ? "small" : "medium"}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <Collapse
                  in={item.open}
                  timeout="auto"
                  unmountOnExit
                  className={classes.collapse}
                  style={{ width: width / props.length }}
                >
                  <List style={{ padding: 0 }}>
                    {item.list.map((option) => (
                      <ListItem
                        button
                        className={classes.collapseItem}
                        onClick={() => {
                          item.setOpen(!item.open);
                          item.onClick(option);
                        }}
                        key={option.id ? option.id : option}
                      >
                        <Typography className={classes.collapseText}>
                          {option.name ? option.name : option.toUpperCase()}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </div>
            )}
          </>
        ))}
      </div>
    </React.Fragment>
  );
};

export default SubheaderComponent;
